import React from 'react';
import { Fab, Paper, Stack as MuiStack } from '@mui/material';
import { DataTypeProvider, FilteringState } from '@devexpress/dx-react-grid';
import { Grid, TableColumnResizing, TableFilterRow, TableHeaderRow, VirtualTable } from '@devexpress/dx-react-grid-material-ui';
import { applyGridTableFilter, vehicleToStringRaw } from './_Utils/AppDocuCommon';
import AddPacketDialog from './Packet_Components/AddPacketDialog';
import ActionsTypeProvider from './Packet_TypeProviders/ActionsTypeProvider';
import RowNumTypeProvider from './_Utils/RowNumTypeProvider';
import { tableColumns, tableColumnWidths, tableColumnExtensions, tableFilteringStateColumnExtensions } from './Packet_Components/_GridTableProps';
import AddIcon from '@mui/icons-material/Add';
import DescriptionIcon from '@mui/icons-material/Description';
import AppDocuServiceCall from './_Utils/AppDocuServiceCall';
import LinearProgress from '@mui/material/LinearProgress';
import OtherAccessoriesTypeProvider from './Packet_TypeProviders/OtherAccessoriesTypeProvider';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import EcuTypeTypeProvider from './_Utils/EcuTypeTypeProvider';
import ComBrandTypeProvider from './_Utils/ComBrandTypeProvider';
import StatusTypeProvider from './Packet_TypeProviders/StatusTypeProvider';
import { DateTypeProvider } from './_Utils/DateTypeProvider';

class AppDocuPacketPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tableColumnWidths: tableColumnWidths,
      tableFilters: [],
      localPackets: this.getFilteredPackets(props.packets, []),
      packageCodes: [],
      addPacketDialogIsOpen: false,            
      reportMenuAnchorEl: null,
    };
  }

  async componentDidMount() {
    // load package codes once for child dialogs
    try {
      const res = await AppDocuServiceCall.getPacketCodes();
      const data = res && res.data ? res.data : res;
      const arr = Array.isArray(data) ? data : (data && Array.isArray(data.codes) ? data.codes : []);
      arr.sort((a, b) => {
        const ta = (a && a.type) ? String(a.type) : '';
        const tb = (b && b.type) ? String(b.type) : '';
        if (ta < tb) return -1;
        if (ta > tb) return 1;
        const ca = (a && a.code) ? String(a.code) : '';
        const cb = (b && b.code) ? String(b.code) : '';
        return ca.localeCompare(cb, undefined, { numeric: true });
      });
      this.setState({ packageCodes: arr });
    } catch (e) {
      this.setState({ packageCodes: [] });
    }
  }
  getFilteredPackets(packets, filters) {
    let filteredPackets = packets || [];
    filteredPackets = filteredPackets.filter(row => {
      return filters.every(f => {
        const col = tableColumns.find(c => c.name === f.columnName);
        const isNumber = col && col.isNumber;
        return applyGridTableFilter(row[f.columnName], f.value, f.operation || "contains", isNumber);
      });
    });
    ///console.log("Filtered packets:", filteredPackets, "with filters:", filters);
    // Calcola row_num dopo il filtro e aggiungi onEdit per ogni riga
    filteredPackets = filteredPackets.map((m, idx) => ({
      ...m,
      row_num: idx + 1,      
    }));
    return filteredPackets;
  }
  setTableFilters(value) {
    this.setState({
      tableFilters: value,
      localPackets: this.getFilteredPackets(this.props.packets, value)
    });
  }
  componentDidUpdate(prevProps) {
    if (prevProps.packets !== this.props.packets) {
      this.setState({
        localPackets: this.getFilteredPackets(this.props.packets, this.state.tableFilters)
      });
    }
  }  
  handleReportMenuOpen = (event) => {
    this.setState({ reportMenuAnchorEl: event.currentTarget });
  };
  handleReportMenuClose = () => {
    this.setState({ reportMenuAnchorEl: null });
  };
  handleReportClick = async () => {
    this.handleReportMenuClose();
    let report = '';
    let allMachines = [];
    try {
      const res = await AppDocuServiceCall.getPacketVehicles(-1);
      if (res.data && res.data.is_valid === false) {
        report = 'Errore recupero dati globali';
      } else {
        allMachines = res.data.machines || [];
      }
    } catch {
      report = 'Errore recupero dati globali';
    }
    const { localPackets } = this.state;
    for (let idx = 0; idx < localPackets.length; idx++) {
      const pkg = localPackets[idx];
      report += `ID: ${pkg.id}\nDESCRIPTION: ${pkg.name}\n`;
      const machines = allMachines.filter(m => m.packet_id === pkg.id);
      if (machines.length > 0) {
        for (let i = 0; i < machines.length; i++) {
          const m = machines[i];
          report += `  - ${vehicleToStringRaw(m.machine_id, m)}\n`;
        }
      } else {
        report += '  (No associated cars)\n';
      }
      report += '\n';
    }
    window.open().document.write(`<pre>${report}</pre>`);
  }
  handleReportSinteticoClick = () => {
    this.handleReportMenuClose();
    const { localPackets } = this.state;
    let report = '';
    for (let idx = 0; idx < localPackets.length; idx++) {
      const pkg = localPackets[idx];
      report += `${pkg.name || ''}\n`;
    }
    window.open().document.write(`<pre>${report}</pre>`);
  }
  render() {
    var height = "calc(100vh - " + this.props.navbarHeight + ")"
    return (
      <Paper>
        <MuiStack direction="row" spacing={2} sx={{ position: 'fixed', bottom: (theme) => theme.spacing(3), right: (theme) => theme.spacing(5), zIndex: 1200 }}>
          <Fab
            onClick={() => this.setState({ addPacketDialogIsOpen: true })}
            variant="extended"
            color="primary"
            aria-label="add"            
          >
            <AddIcon sx={{ mr: 1 }} />
            ADD NEW
          </Fab>
          <Fab
            onClick={this.handleReportMenuOpen}
            variant="extended"
            color="secondary"
            aria-label="report"            
          >
            <DescriptionIcon sx={{ mr: 1 }} />
            REPORT
          </Fab>
          <Menu
            anchorEl={this.state.reportMenuAnchorEl}
            open={Boolean(this.state.reportMenuAnchorEl)}
            onClose={this.handleReportMenuClose}
          >
            <MenuItem onClick={this.handleReportClick}>Report completo</MenuItem>
            <MenuItem onClick={this.handleReportSinteticoClick}>Lista pacchetti</MenuItem>
          </Menu>
        </MuiStack>
        
        <Grid 
          rows={this.state.localPackets}
          columns={tableColumns}
          getRowId={row => row.id}
        >
          <ActionsTypeProvider 
            for={[ "actions" ]} 
            onItemsChange={this.props.onItemsChange}
            packageCodes={this.state.packageCodes} />
          <StatusTypeProvider for={["status"]} />
          <DateTypeProvider for={["created_at", "updated_at"]} /> 
          <RowNumTypeProvider for={[ "row_num" ]} /> 
          <OtherAccessoriesTypeProvider for={[ "other_accessories" ]} /> 
          <ComBrandTypeProvider for={[ "com_brand" ]} />          
          <EcuTypeTypeProvider for={[ "ecu_type" ]} />          
          <DataTypeProvider  
            for={[ "id" ]}
            availableFilterOperations={[ 'equal', 'notEqual', 'greaterThan', 'greaterThanOrEqual', 'lessThan', 'lessThanOrEqual' ]} />
          <VirtualTable 
            height={height}
            columnExtensions={tableColumnExtensions}
          />
          <FilteringState
            filters={this.state.tableFilters}
            onFiltersChange={this.setTableFilters.bind(this)}
            columnExtensions={tableFilteringStateColumnExtensions} />
          <TableColumnResizing
            columnWidths={this.state.tableColumnWidths}
            onColumnWidthsChange={value => this.setState({ tableColumnWidths: value })} />
          <TableHeaderRow contentComponent={props => (<TableHeaderRow.Content {...props} style={{ minHeight: 0, height: 0, paddingTop: 0, paddingBottom: 0, fontSize: 12 }} />)} />
          <TableFilterRow showFilterSelector />
        </Grid>

        <AddPacketDialog
          isOpen={this.state.addPacketDialogIsOpen}
          onClose={() => this.setState({ addPacketDialogIsOpen: false })}
          onItemsChange={this.props.onItemsChange}
          packageCodes={this.state.packageCodes}
        />
      </Paper>
    );
  }
}

export default AppDocuPacketPage;
